import { useContext } from 'react'
import { LanguageContext } from '../../contexts/language'
import content from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'
import './Header.css'

const Header = () => {
  const { language } = useContext(LanguageContext)
  const { title } = content[language].header

  return (
    <header className='header center'>
      <div style={{display: 'flex', alignItems: 'center', gap: '1.5em'}}>
        <h3 style={{margin: 0}}>
          <a href="/" className='link'>
            {title}
          </a>
        </h3>
        <LanguageSwitcher />
      </div>
      <Navbar />
    </header>
  )
}

export default Header
